/* tslint:disable */
/* eslint-disable */
/**
 * ciselniky Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CiselnikPolozka
 */
export interface CiselnikPolozka {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'nazov': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozka
     */
    'uroven'?: number;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'prefix'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'legislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'platny': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'existujeFormular'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'generovanySystemom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'povolitZadavanieFormularom'?: boolean;
}
/**
 * 
 * @export
 * @interface CiselnikPolozkaNode
 */
export interface CiselnikPolozkaNode {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozkaNode
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozkaNode
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozkaNode
     */
    'kod': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozkaNode
     */
    'uroven'?: number;
    /**
     * 
     * @type {Array<CiselnikPolozkaNode>}
     * @memberof CiselnikPolozkaNode
     */
    'polozky'?: Array<CiselnikPolozkaNode>;
}
/**
 * 
 * @export
 * @interface CiselnikPolozkaTree
 */
export interface CiselnikPolozkaTree {
    /**
     * 
     * @type {Array<CiselnikPolozkaNode>}
     * @memberof CiselnikPolozkaTree
     */
    'rootList': Array<CiselnikPolozkaNode>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TypCiselnikaEnum = {
    LegislativnaOblast: 'LEGISLATIVNA_OBLAST',
    Jazyk: 'JAZYK',
    TypAktEu: 'TYP_AKT_EU',
    Institucia: 'INSTITUCIA',
    TypMaterialu: 'TYP_MATERIALU',
    StupenUtajenia: 'STUPEN_UTAJENIA',
    UzemnaPlatnost: 'UZEMNA_PLATNOST',
    TypDokumentuAktEu: 'TYP_DOKUMENTU_AKT_EU',
    TypSprievodnehoDokumentu: 'TYP_SPRIEVODNEHO_DOKUMENTU',
    ClanokDohovoruEsLp: 'CLANOK_DOHOVORU_ES_LP',
    TypJudikatuEsLp: 'TYP_JUDIKATU_ES_LP'
} as const;

export type TypCiselnikaEnum = typeof TypCiselnikaEnum[keyof typeof TypCiselnikaEnum];



/**
 * CiselnikPolozkaExternalApi - axios parameter creator
 * @export
 */
export const CiselnikPolozkaExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get ciselnik polozky.
         * @param {Array<string>} [ids] One or more ids.
         * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
         * @param {boolean} [valid] valid for ciselnik polozka.
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCiselnikPolozka: async (ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/polozky-ciselnika`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (typy) {
                localVarQueryParameter['typy'] = typy.join(COLLECTION_FORMATS.csv);
            }

            if (valid !== undefined) {
                localVarQueryParameter['valid'] = valid;
            }

            if (hladanyNazov !== undefined) {
                localVarQueryParameter['hladanyNazov'] = hladanyNazov;
            }

            if (kody) {
                localVarQueryParameter['kody'] = kody.join(COLLECTION_FORMATS.csv);
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CiselnikPolozkaExternalApi - functional programming interface
 * @export
 */
export const CiselnikPolozkaExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CiselnikPolozkaExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get ciselnik polozky.
         * @param {Array<string>} [ids] One or more ids.
         * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
         * @param {boolean} [valid] valid for ciselnik polozka.
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCiselnikPolozka(ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CiselnikPolozka>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCiselnikPolozka(ids, typy, valid, hladanyNazov, kody, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CiselnikPolozkaExternalApi.getCiselnikPolozka']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CiselnikPolozkaExternalApi - factory interface
 * @export
 */
export const CiselnikPolozkaExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CiselnikPolozkaExternalApiFp(configuration)
    return {
        /**
         * Get ciselnik polozky.
         * @param {Array<string>} [ids] One or more ids.
         * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
         * @param {boolean} [valid] valid for ciselnik polozka.
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCiselnikPolozka(ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options?: any): AxiosPromise<Array<CiselnikPolozka>> {
            return localVarFp.getCiselnikPolozka(ids, typy, valid, hladanyNazov, kody, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CiselnikPolozkaExternalApi - object-oriented interface
 * @export
 * @class CiselnikPolozkaExternalApi
 * @extends {BaseAPI}
 */
export class CiselnikPolozkaExternalApi extends BaseAPI {
    /**
     * Get ciselnik polozky.
     * @param {Array<string>} [ids] One or more ids.
     * @param {Array<TypCiselnikaEnum>} [typy] One or more typ.
     * @param {boolean} [valid] valid for ciselnik polozka.
     * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
     * @param {Array<string>} [kody] One or more kod. This is exact case sensitive filtering. If you have polozka with kod &#x60;Code&#x60; these string will NOT match it &#x60;Cod&#x60;, &#x60;code&#x60;.
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CiselnikPolozkaExternalApi
     */
    public getCiselnikPolozka(ids?: Array<string>, typy?: Array<TypCiselnikaEnum>, valid?: boolean, hladanyNazov?: string, kody?: Array<string>, limit?: number, options?: RawAxiosRequestConfig) {
        return CiselnikPolozkaExternalApiFp(this.configuration).getCiselnikPolozka(ids, typy, valid, hladanyNazov, kody, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HierarchickyCiselnikTreeExternalApi - axios parameter creator
 * @export
 */
export const HierarchickyCiselnikTreeExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get tree of hierarchicky ciselnik.
         * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHierarchickyCiselnikTree: async (typ?: TypCiselnikaEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ciselnik-polozky/hierarchicky`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HierarchickyCiselnikTreeExternalApi - functional programming interface
 * @export
 */
export const HierarchickyCiselnikTreeExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HierarchickyCiselnikTreeExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get tree of hierarchicky ciselnik.
         * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHierarchickyCiselnikTree(typ?: TypCiselnikaEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CiselnikPolozkaTree>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHierarchickyCiselnikTree(typ, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchickyCiselnikTreeExternalApi.getHierarchickyCiselnikTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HierarchickyCiselnikTreeExternalApi - factory interface
 * @export
 */
export const HierarchickyCiselnikTreeExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HierarchickyCiselnikTreeExternalApiFp(configuration)
    return {
        /**
         * Get tree of hierarchicky ciselnik.
         * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHierarchickyCiselnikTree(typ?: TypCiselnikaEnum, options?: any): AxiosPromise<CiselnikPolozkaTree> {
            return localVarFp.getHierarchickyCiselnikTree(typ, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HierarchickyCiselnikTreeExternalApi - object-oriented interface
 * @export
 * @class HierarchickyCiselnikTreeExternalApi
 * @extends {BaseAPI}
 */
export class HierarchickyCiselnikTreeExternalApi extends BaseAPI {
    /**
     * Get tree of hierarchicky ciselnik.
     * @param {TypCiselnikaEnum} [typ] Typ of hierarchicky ciselnik.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchickyCiselnikTreeExternalApi
     */
    public getHierarchickyCiselnikTree(typ?: TypCiselnikaEnum, options?: RawAxiosRequestConfig) {
        return HierarchickyCiselnikTreeExternalApiFp(this.configuration).getHierarchickyCiselnikTree(typ, options).then((request) => request(this.axios, this.basePath));
    }
}



